import { Label } from 'components/Form/components/Label';
import { composeValidators } from 'components/Form/validate';
import { Message } from 'models';
import React, { ChangeEventHandler, ReactNode } from 'react';
import { Field } from 'react-final-form';

import { ChoiceError } from '../ChoiceError';
import * as S from './checkbox.styles';

interface CheckboxProps {
  name: string;
  label: string | ReactNode;
  id?: string;
  checked?: boolean;
  validate?: Array<(inputValue: unknown) => undefined | Message>;
  disabled?: boolean;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  value?: string;
}

export class Checkbox extends React.Component<CheckboxProps> {
  onFieldChange = (e: React.ChangeEvent<HTMLInputElement>, FFonFieldChange: ChangeEventHandler<HTMLInputElement>) => {
    FFonFieldChange(e);
    if (typeof this.props.onChange === 'function') this.props.onChange(e);
  };

  render() {
    // Random ID is generated if id is not set (this way labels will stay accessible).
    const { name, label, validate, id = crypto.randomUUID(), checked, disabled, value, ...rest } = this.props;

    const isRequired = !!(validate && validate.length && validate.find((validation) => validation.name === 'required'));

    return (
      <React.Fragment>
        <Field
          name={name}
          type="checkbox"
          validate={validate ? composeValidators(validate) : undefined}
          render={({ input }) => (
            <S.Checkbox className="checkbox">
              <Label isRequired={isRequired} htmlFor={`${id}`}>
                <input
                  {...input}
                  {...rest}
                  id={`${id}`}
                  type="checkbox"
                  value={value}
                  checked={checked}
                  disabled={disabled}
                  onChange={(e) => this.onFieldChange(e, input.onChange)}
                />
                <span>{label}</span>
              </Label>
            </S.Checkbox>
          )}
        />
        <ChoiceError name={name} />
      </React.Fragment>
    );
  }
}
